import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { InitiateRedirection, RedirectionSelectors } from '../store';
import { RedirectionViewState } from '../types';

@Component({
  selector: 'app-redirection-callback',
  templateUrl: './redirection-callback.component.html',
  standalone: false,
})
export class RedirectionCallbackComponent implements OnInit {
  viewState$: Observable<RedirectionViewState>;

  redirectionViewStateEnum = RedirectionViewState;

  @HostBinding('class')
  private classes = 'flex items-center justify-center h-full w-full';

  constructor(private route: ActivatedRoute, private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(InitiateRedirection({ redirectionParams: this.route.snapshot.queryParams }));
    this.viewState$ = this.store.pipe(select(RedirectionSelectors.selectViewState));
  }
}
